const FrontPageLuchoFest = ({ isActiveWomensMode }) => {
    return (
        <>
            <div className='FrontPage--Riddle__Screen__Background'>
                {isActiveWomensMode ? (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='FrontPage--Riddle__Screen__Background__Image' />
                ) : isActiveWomensMode === false && (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Varonil.png' className='FrontPage--Riddle__Screen__Background__Image' />
                )}
            </div>

            <div className="FrontPageNoisemeter__Screen__Container">
                <img src='/img/page/adsl-five.png' className='FrontPageNoisemeter__Screen__Container__Logo' />
                <p className="FrontPageNoisemeter__Screen__Container__Title" style={{ fontFamily: '"GFS Didot", serif' }}>Lucho Fest</p>
            </div>

            <footer className='SelfieFan__Screen__QR__Footer FooterCredits'>Hecho con ♥ por Interaktia | 2026</footer>
        </>
    )
}

export { FrontPageLuchoFest };